import React from "react";
import "./HisabBook_ServiceSection.css";
import { FaBook, FaClipboardList, FaBell, FaHistory, FaGlobe, FaCloudUploadAlt, FaUserFriends, FaChartPie, FaLock } from 'react-icons/fa';

// import Lock_Unlock from "./src/img/dshield";

const services = [
  {
    icon: FaBook,
    imgAlt: "Easy Account Management",
    title: "Easy Account Management",
    description: "Organize accounts and daily transactions efficiently with a streamlined interface, reducing errors and saving time for better financial management."
  },
  {
    icon: FaClipboardList,
    imgAlt: "Digital Ledger System",
    title: "Digital Ledger System",
    description: "Replace traditional methods with a secure, easy-to-use digital ledger, accessible anytime and anywhere for complete convenience."
  },
  {
    icon: FaBell,
    imgAlt: "Reminders for Payments",
    title: "Reminders for Payments",
    description: "Stay on track with timely reminders for payments, improving financial discipline and maintaining excellent relationships with customers or vendors."
  },
  {
    icon: FaHistory,
    imgAlt: "Transaction History",
    title: "Transaction History",
    description: "Review and filter past transactions effortlessly, allowing you to monitor trends, analyze finances, and make informed decisions."
  },
  {
    icon: FaGlobe,
    imgAlt: "Multi-Language Support",
    title: "Multi-Language Support",
    description: "Access the app in multiple languages for a user-friendly experience tailored to your preferences and better understanding."
  },
  {
    icon: FaCloudUploadAlt,
    imgAlt: "Data Backup & Restore",
    title: "Data Backup & Restore",
    description: "Ensure your financial data is safely stored and easily restored whenever needed, safeguarding crucial information."
  },
  {
    icon: FaUserFriends,
    imgAlt: "Customer Insights",
    title: "Customer Insights",
    description: "Gain insights into customer behavior and transaction trends to grow your business effectively."
  },
  {
    icon: FaChartPie,
    imgAlt: "Reports Generation",
    title: "Reports Generation",
    description: "Generate detailed financial reports for better decision-making and improved business planning."
  },
  {
    icon: FaLock,
    imgAlt: "Secure Data Handling",
    title: "Secure Data Handling",
    description: "Protect sensitive financial data with robust encryption, ensuring it is safe from unauthorized access at all times."
  },

];


const ServiceSection = () => {
  return (
    <div className="section harsafe-servicess-section section-padding">
      <div className="container">
        <div className="services-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">Services</h3>
            <h2 className="title">Affordable Services for all</h2>
          </div>
          <div className="service-content-wrap">
            <div className="row right_choice_inner best_choice_inner mt-3">
              {services.map((service, index) => (
                <div key={index} className="col-lg-4 col-sm-6">
                  <div className="counter-item choice-item grayscale_img">
                    <div className="modalBoximg">
                    <service.icon className="service-icon" />
                      {/* <img src={service.imgSrc} alt={service.imgAlt} /> */}
                    </div>
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
